import { render, staticRenderFns } from "./EidtInformation.vue?vue&type=template&id=2b5bf0ca"
import script from "./EidtInformation.vue?vue&type=script&lang=js"
export * from "./EidtInformation.vue?vue&type=script&lang=js"
import style0 from "./EidtInformation.vue?vue&type=style&index=0&id=2b5bf0ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports